export default __webpack_public_path__ + "static/media/AddImageIcon.51d5cb0a.svg";